module.exports = __webpack_public_path__ + "img/bg-vip-tc.9db92f3f.png";